/** Fautes listées par le serveur quand des villas ne peuvent pas être regroupées (une ligne par villa ou par règle du dossier). */
export default function GroupFaults({ faults }) {
  if (!faults?.length) return null;
  return (
    <div role="alert" data-testid="partner-group-faults" className="rounded-sm border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm text-amber-900">
      <p className="font-semibold mb-1">Ces propositions ne peuvent pas être regroupées :</p>
      <ul className="list-disc pl-5 space-y-1">
        {faults.map((f) => <li key={f.key}>{f.message}</li>)}
      </ul>
    </div>
  );
}
